<template>
  <div id="pmlst-titlebar">
    <div class="pmlst-titlebar-wrapper">
      <slot><h1>Selection Tool</h1></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'title-bar'
}
</script>
